import thumbnail from "../../../assets/images/projects/sedap/homepage-banner.png";
import { ProjectDataProps } from "../props";

export default {
  title: "Exploring a Systematic Feedback Loop for Traveloka Insurance",
  description:
    "Designing a feedback system that connected user behavior, product proposals, and shared decision making.",
  image: thumbnail,
  path: "/traveloka-sedap",
  thumbnailBackground: "linear-gradient(145deg, #0b466d 0%, #078e97 50%, #e91d8f 140%)",
  thumbnailFit: "cover",
  thumbnailPosition: "center bottom",
  thumbnailScale: 1,
} as ProjectDataProps;
